import React, { useEffect, useState } from 'react';

import AdviceSection from '../common/AdviceSection';
import SubMenuTabs from '../common/subMenuTabs/SubMenuTabs';
import CountryProfileTextTab from '../common/CountryProfileTextTab';
import Methodology from '../common/Methodology';
import Related from '../common/Related';

import { regulationsTab } from '../../model/subMenuTabs';

import { getOSHData } from '../../api';

const Regulation = props => {

	const lockedCountry = 'EU27_2020';
	const currentPath = '/osh-steering/regulation/';
	const filters = {
		countries: [
			{code: 'EU27_2020'}
		]
	};
	const noInfoTexts1 = [];
	
	let selected = '';
	for (let i = 0; i < regulationsTab.length; i++)
	{
		if (regulationsTab[i].url == props.indicator)
		{
			selected = regulationsTab[i];
		}
	}

	const [selectedTab, setSelectedTab] = useState(selected);
	const [countryData1, setCountryData1] = useState({});

	useEffect(() => {
		getRegulationsData();

		// Update the title of the page
		document.title = props.literals.L22006 +  " - " + props.literals.L22020 + " - " + props.literals.L363;
	}, [])

	const getRegulationsData = () => {
		getOSHData('STRATEGY_REGULATION', filters)
		.then((res) => {
			const euData = res.resultset;
			setCountryData1(euData[0] || [])
		})
	}

	const callbackSelectedTab = (callback) => {
		for (let i = 0; i < regulationsTab.length; i++)
		{
			if (regulationsTab[i].url == callback)
			{
				setSelectedTab(regulationsTab[i]);
			}
		}
	}

	return(
		<div className="regulation">
			<AdviceSection literals = { props.literals } section = { [ "osh-steering","regulation" ] } methodologyData = { { section: 'osh-steering', subsection: 'Regulation', indicator: 412 } } />

			<div>
				<SubMenuTabs 
					literals = { props.literals }
					selectedTab = { selectedTab.url }
					callbackSelectedTab = { callbackSelectedTab }
					locationPath = { currentPath }
					subMenuTabs = { regulationsTab }
				/>
			</div>

			<div className="line background-main-light"></div>

			<div className="container section--page card--grid xxs-w1 xs-w1 w1">
				{regulationsTab.map((element) => {
					if (element.url == selectedTab.url) {
						return (
							<div key = { element.literalTab } className="container section--page full-tablet" >
								<CountryProfileTextTab
									tabName = { element.literalTab }
									literals = { props.literals }
									country1Text = { countryData1[`text${ selectedTab.textIndex }`] }
									country1 = { countryData1.country }
									noInfoMsg1 = { noInfoTexts1 }
									maxCharacters = { 400 }
									page = { 'regulation' }
								/>
							</div>
						)
					}
				})}	
			</div>
		
			<Methodology literals = { props.literals } section = { 'Regulation' } indicator = { selectedTab.indicator } />
			<Related literals = { props.literals } section = { ["osh-steering","regulation"] } />		
		</div>
	)
}
Regulation.displayName = 'Regulation';
export default Regulation;